import React from "react";
import { useOrganisation } from "../contexts/OrganisationContext";
import TesterReview from "./TesterReview";
import ReviewerReview from "./ReviewerReview";

/**
 * Role switch for /testrapporter/granska/:executionId: reviewers get the
 * review actions view, testers get their own (clarify/resubmit) view.
 */
const ReviewAnswersPage = () => {
  const { activeRoleId } = useOrganisation();
  const isReviewer = activeRoleId === "inera-reviewer";
  return isReviewer ? <ReviewerReview /> : <TesterReview />;
};

export default ReviewAnswersPage;
